export class SnackbarState {
    message: ISnackbarMessage = {
        isShown: false,
        message: '',
        timeout: 1200,
        type: '',
        actionText: undefined,
        onAction: undefined,
    };
}

export interface ISnackbarMessage {
    type: '' | 'success' | 'error' | 'info' | 'warning';
    message: string;
    timeout: number;
    isShown: boolean;
    /** Optional action button text (e.g., "More details") */
    actionText?: string;
    /** Callback when action button is clicked */
    onAction?: () => void;
}
